// Baseado no projeto tempo-design-tokens Url(https://dev.azure.com/hsl-dev/Tempo%20-%20Design%20System/_git/tempo-design-tokens)
// Copia do Arquivo: node_modules\@tempo\tempo-tokens\dist\js\hsl\default.js
// Data: 23/08/2023
// @Author: Pedro Freitas - Hospital Sírio-Libanês
// Obs: Arquivo criado devido a incompatibildiade de componentes do Design System Tempo com o typescript
export interface BrandTokensProps {
    
    //Colors
    FeedbackColorErrorPure: string;
    FeedbackColorErrorLight: string;
    FeedbackColorErrorMedium: string;
    FeedbackColorErrorDark: string;
    FeedbackColorSuccessPure: string;
    FeedbackColorSuccessLight: string;
    FeedbackColorSuccessMedium: string;
    FeedbackColorSuccessDark: string;
    HighlightColorPure: string;
    HighlightColorLight: string;
    HighlightColorMedium: string;
    HighlightColorDark: string;
    NeutralColorLowPure: string;
    NeutralColorLowLight: string;
    NeutralColorLowMedium: string;
    NeutralColorLowDark: string;
    NeutralColorHighPure: string;
    NeutralColorHighLight: string;
    NeutralColorHighMedium: string;
    NeutralColorHighDark: string;
    BrandColorPrimaryPure: string;
    BrandColorPrimaryLight: string;
    BrandColorPrimaryMedium: string;
    BrandColorPrimaryDark: string;
    
    //Fonts
    FontFamily: string;
    FontWeightBold: number | string;
    FontWeightMedium: number | string;
    FontWeightRegular: number | string;

}


export const BrandTokens: Partial<BrandTokensProps> = {
    //Colors
    FeedbackColorErrorPure: "#E93535",
    FeedbackColorErrorLight: "#FDC4C4",
    FeedbackColorErrorMedium: "#F17F7F",
    FeedbackColorErrorDark: "#710A0A",
    FeedbackColorSuccessPure: "#35973C",
    FeedbackColorSuccessLight: "#D2EFD4",
    FeedbackColorSuccessMedium: "#95DA9A",
    FeedbackColorSuccessDark: "#205A24",
    HighlightColorPure: "#FF981F",
    HighlightColorLight: "#FFE3C2",
    HighlightColorMedium: "#CC6E00",
    HighlightColorDark: "#7A4200",
    NeutralColorLowPure: "#000000",
    NeutralColorLowLight: "#A3A3A3",
    NeutralColorLowMedium: "#666666",
    NeutralColorLowDark: "#292929",
    NeutralColorHighPure: "#FFFFFF",
    NeutralColorHighLight: "#F5F5F5",
    NeutralColorHighMedium: "#E0E0E0",
    NeutralColorHighDark: "#CCCCCC",
    BrandColorPrimaryPure: "#2C6EF2",
    BrandColorPrimaryLight: "#C5D7FB",
    BrandColorPrimaryMedium: "#4985FD",
    BrandColorPrimaryDark: "#0A3A99",

    //Fonts
    FontFamily: "Inter",
    FontWeightBold: 700,
    FontWeightMedium: 500,
    FontWeightRegular: 400,
}